import { axiosInstanceReport } from "../axios";
import { Cards, RequestResponse } from "../types";

export const getCardDetails = async (
  pageNumber: number,
  pageSize: number,
  startDate?: string,
  endDate?: string
): Promise<RequestResponse<{ records: Cards[]; total: number }>> => {
  try {
    const params = {
      pageNumber,
      pageSize,
      startDate,
      endDate
    };
    const response = await axiosInstanceReport.get(
      "/transactions/mobile/filter",
      {
        params
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data,
        total: response.data.count
      }
    };
  } catch (err: any) {
    console.error("Unable to fetch mobile transactions: ", err);
    return {
      error: true,
      message: err.response.data?.errorMessage || err.message || err,
      data: null
    };
  }
};

export const downloadCSV = async (
  startDate: string,
  endDate: string,
  fileNumber: string
): Promise<{ data: Blob }> => {
  try {
    const response = await axiosInstanceReport.get(
      `/transactions/mobile/export/csv?startDate=${startDate}&endDate=${endDate}&fileNumber=${fileNumber}`,
      {
        responseType: "blob"
      }
    );

    return { data: response.data };
  } catch (error) {
    console.error("Error downloading CSV:", error);
    throw error;
  }
};
